import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TermsAndConditions = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <h1>Terms & Conditions</h1>
        <p>Effective Date: July 9, 2025</p>
      </Header>

      <Section data-aos="fade-up">
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Totomart (owned by Ligiotech Solutions Pvt Ltd), you agree to be bound by these Terms and Conditions, our Privacy Policy, and any additional guidelines posted on the site. If you do not agree, please do not use our platform.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>2. Services Offered</h2>
        <p>
          Totomart offers online property listing, tenant discovery, rental payments, documentation services, and related property support solutions. We do not guarantee property transactions or tenant/owner behavior.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>3. User Responsibilities</h2>
        <ul>
          <li>Users must provide accurate, lawful, and updated information.</li>
          <li>Property listings must not contain misleading or offensive content.</li>
          <li>Users are responsible for securing their login credentials.</li>
          <li>Tenants and owners must comply with applicable housing laws.</li>
        </ul>
      </Section>

      <Section data-aos="fade-up">
        <h2>4. Account Suspension</h2>
        <p>
          Totomart reserves the right to suspend or terminate any user account that violates these terms, engages in fraudulent activity, or poses a security risk to the platform or others.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>5. Payment and Refunds</h2>
        <p>
          Users must agree to our <a href="/refund-policy">Refund & Cancellation Policy</a> before using any paid services. Totomart facilitates online rent payments and listing upgrades through third-party gateways.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>6. Intellectual Property</h2>
        <p>
          All content, design, and intellectual property on Totomart are owned by Ligiotech Solutions Pvt Ltd. Reproduction, copying, or redistribution of any part of the platform without consent is strictly prohibited.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>7. Limitation of Liability</h2>
        <p>
          Totomart is a digital facilitator. We do not take responsibility for user-generated content, unsuccessful rental negotiations, or disputes between users. Our liability is limited to the amount paid for any failed service.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>8. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India. Any legal disputes shall fall under the jurisdiction of Chennai, Tamil Nadu courts only.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>9. Changes to Terms</h2>
        <p>
          We reserve the right to modify these Terms at any time. Continued use of the platform after updates implies your acceptance of the revised terms.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>10. Contact Information</h2>
        <p>
          For queries or concerns regarding these Terms, please contact:
        </p>
        <p>
          Totomart Support<br />
          Email: support@totomart.in<br />
          Phone: +91-7373339225<br />
          Address: No. 71, Appar Street, Thiruvalleswarar Nagar, Thirumangalam, Anna Nagar, Chennai – 600040
        </p>
      </Section>

      <FooterNote data-aos="fade-in">
        <p>Totomart – Making Real Estate Simple, Safe, and Transparent.</p>
      </FooterNote>
    </Wrapper>
  );
};

export default TermsAndConditions;

// Styled-components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    font-size: 2.4rem;
    color: #e53935;
  }

  p {
    color: #666;
    font-size: 1rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;

  h2 {
    color: #b71c1c;
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    color: #444;
  }

  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.5rem;
      list-style-type: disc;
      font-size: 1rem;
      color: #444;
    }
  }

  a {
    color: #e53935;
    text-decoration: underline;
  }
`;

const FooterNote = styled.div`
  text-align: center;
  color: #777;
  font-size: 0.95rem;
  margin-top: 3rem;
  border-top: 1px solid #eee;
  padding-top: 1.5rem;
`;
